"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeFaq = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var mapStateToProps = function (state) { return ({
    faqs: state.place.faqs,
    nameFaq: state.place.t.faq,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    onFaqClicked: function (index) { return dispatch(PlaceAction_1.default.onFaqClicked(index)); },
}); };
exports.placeFaq = function (props) {
    var renderFaqItem = function (it, index) {
        var itemClass = classnames_1.default('c-faq__item', { 'c-faq__item--expand': it.opened });
        var onFaqClicked = function () { return props.onFaqClicked(index); };
        var content = {
            dangerouslySetInnerHTML: {
                __html: it.answer,
            },
        };
        return (React.createElement("div", { key: index, onClick: onFaqClicked, className: itemClass, style: { cursor: 'pointer' } },
            React.createElement("div", { className: "c-faq__question", dangerouslySetInnerHTML: { __html: it.question } }),
            React.createElement("div", { className: "c-faq__answer" },
                React.createElement("div", __assign({ className: "c-faq__answer-text" }, content)),
                it.date ? React.createElement("div", { className: "c-faq__answer-date" }) : null)));
    };
    return props.faqs ? (React.createElement("div", { className: "c-faq" },
        React.createElement("div", { className: "l-container l-container--lr" },
            React.createElement("div", { className: "c-faq__content t--darker" },
                React.createElement("div", { className: "c-faq__title o-h1 o-h1--serif u-preserve-cap u-text-center l-pad--2 l-pad-around" }, props.nameFaq),
                React.createElement("div", { className: "c-faq__body" },
                    React.createElement("div", { className: "c-faq__items" }, props.faqs.map(renderFaqItem))))))) : null;
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.placeFaq);
